import { render } from "./KatInput.vue?vue&type=template&id=8f67fa8a&scoped=true"
import script from "./KatInput.vue?vue&type=script&lang=js"
export * from "./KatInput.vue?vue&type=script&lang=js"

import "./KatInput.vue?vue&type=style&index=0&id=8f67fa8a&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f67fa8a"]])

export default __exports__